const content = {
  title: "Exclusive Privileges",
  description: {
    en:
      "Sanctuary Club members receive preferential treatment across the Banyan Group network of heritage hideaways, urban pied-à-terres and tropical getaways",
    ru:
      "Участники программы Sanctuary Club предлагается привилегированное обслуживание на исторических и тропических направлениях, а также в городских резиденциях в рамках всемирной сети комплексов корпорации Banyan Group .",
    cn:
      "榕源会的会员将享受到悦榕集团旗下传统私密之旅、现代都市之旅以及热带度假之旅的专属特权。",
  },
  subTitle: {
    en: "Discount privileges at worldwide resorts",
    ru: "СКИДКИ В КУРОРТНЫХ КОМПЛЕКСАХ ПО ВСЕМУ МИРУ",
    cn: "在世界各地度假村的折扣",
  },
};

const imageContent = [
  {
    id: 1,
    title: {
      en: ["Hotel accommodation *"],
      cn: ["酒店住宿*"],
      ru: ["Размещение в гостинице*"],
    },
    small: {
      en: [
        "* Best available rate at time of booking, terms & conditions apply",
      ],
      cn: ["*预订时，享有最优折扣, 适用条款与条件"],
      ru: [
        "* Лучшая доступная цена на момент бронирования, действуют правила и условия",
      ],
    },
    thumbnail:
      "https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/images/hotel-ex.jpg",
    image: [
      {
        id: 1,
        caption: {
          en: ["Angsana Lăng Cô, Vietnam"],
          cn: ["Angsana Lăng Cô, Vietnam"],
          ru: ["Angsana Lăng Cô, Vietnam"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/1.1%20Angsana%20Lang%20Co,%20Vietnam.jpg",
      },
      {
        id: 2,
        caption: {
          en: ["Angsana Ihuru, Maldives"],
          cn: ["Angsana Ihuru, Maldives"],
          ru: ["Angsana Ihuru, Maldives"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/1.2 Angsana Ihuru, Maldives.jpg",
      },
      {
        id: 3,
        caption: {
          en: ["Banyan Tree Phuket, Thailand"],
          cn: ["Banyan Tree Phuket, Thailand"],
          ru: ["Banyan Tree Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/2.1 Banyan Tree Phuket, Thailand.jpg",
      },
      {
        id: 4,
        caption: {
          en: ["Banyan Tree Lijiang, China"],
          cn: ["Banyan Tree Lijiang, China"],
          ru: ["Banyan Tree Lijiang, China"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/2.2 Banyan Tree Lijiang, China.jpg",
      },
      {
        id: 5,
        caption: {
          en: ["Banyan Tree Mayakoba, Mexico"],
          cn: ["Banyan Tree Mayakoba, Mexico"],
          ru: ["Banyan Tree Mayakoba, Mexico"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/2.3 Banyan Tree Mayakoba, Mexico.jpg",
      },
      {
        id: 7,
        caption: {
          en: ["Cassia Phuket, Thailand"],
          cn: ["Cassia Phuket, Thailand"],
          ru: ["Cassia Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/3.1 Cassia Phuket, Thailand.jpg",
      },
      {
        id: 8,
        caption: {
          en: ["Cassia Bintan, Indonesia"],
          cn: ["Cassia Bintan, Indonesia"],
          ru: ["Cassia Bintan, Indonesia"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/3.3 Cassia Bintan, Indonesia.jpg",
      },
      {
        id: 9,
        caption: {
          en: ["Dhawa Cayo Santa Maria, Cuba"],
          cn: ["Dhawa Cayo Santa Maria, Cuba"],
          ru: ["Dhawa Cayo Santa Maria, Cuba"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/4. Dhawa Cayo Santa Maria, Cuba.jpg",
      },
      {
        id: 10,
        caption: {
          en: ["Dusit Thani Pool Villas, Thailand"],
          cn: ["Dusit Thani Pool Villas, Thailand"],
          ru: ["Dusit Thani Pool Villas, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/hotel/5. Dusit Thani Pool Villas, Thailand.jpg",
      },
    ],
  },
  {
    id: 2,
    title: {
      en: ["Spa"],
      cn: ["水疗中心"],
      ru: ["Спа-центры"],
    },
    small: {
      en: [""],
      cn: [""],
      ru: [""],
    },
    thumbnail:
      "https://lagunaproperty.com/privilege/spa/1. Banyan Tree Spa.jpg",
    image: [
      {
        id: 1,
        caption: {
          en: ["Angsana Spa Bintan, Indonesia"],
          cn: ["Angsana Spa Bintan, Indonesia"],
          ru: ["Angsana Spa Bintan, Indonesia"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/1. Angsana Spa Bintan, Indonesia.jpg",
      },
      {
        id: 2,
        caption: {
          en: ["Angsana Spa Hotel Nikko Shanghai, China"],
          cn: ["Angsana Spa Hotel Nikko Shanghai, China"],
          ru: ["Angsana Spa Hotel Nikko Shanghai, China"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/2. Angsana Spa Hotel Nikko Shanghai, China.jpg",
      },
      {
        id: 3,
        caption: {
          en: ["Angsana Spa Laguna Phuket, Thailand"],
          cn: ["Angsana Spa Laguna Phuket, Thailand"],
          ru: ["Angsana Spa Laguna Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/3. Angsana Spa Laguna Phuket, Thailand.jpg",
      },
      {
        id: 4,
        caption: {
          en: ["Banyan Tree Spa Phuket, Thailand"],
          cn: ["Banyan Tree Spa Phuket, Thailand"],
          ru: ["Banyan Tree Spa Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/4. Banyan Tree Spa Phuket, Thailand.jpg",
      },
      {
        id: 5,
        caption: {
          en: ["Banyan Tree Spa Lăng Cô, Vietnam"],
          cn: ["Banyan Tree Spa Lăng Cô, Vietnam"],
          ru: ["Banyan Tree Spa Lăng Cô, Vietnam"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/5. Banyan Tree Spa Lang Co, Vietnam.jpg",
      },
      {
        id: 6,
        caption: {
          en: ["Banyan Tree Spa Bintan, Indonesia"],
          cn: ["Banyan Tree Spa Bintan, Indonesia"],
          ru: ["Banyan Tree Spa Bintan, Indonesia"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/6. Banyan Tree Spa Bintan, Indonesia.jpg",
      },
      {
        id: 7,
        caption: {
          en: ["Banyan Tree Spa Marina Bay Sand, Singapore"],
          cn: ["Banyan Tree Spa Marina Bay Sand, Singapore"],
          ru: ["Banyan Tree Spa Marina Bay Sand, Singapore"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/7.Banyan Tree Spa Marina Bay Sand.jpg",
      },
      {
        id: 8,
        caption: {
          en: ["Chill Chill Laguna Phuket, Thailand"],
          cn: ["Chill Chill Laguna Phuket, Thailand"],
          ru: ["Chill Chill Laguna Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/8. Chill Chill Laguna Phuket, Thailand.jpg",
      },
      {
        id: 9,
        caption: {
          en: ["Chill Chill Laguna Phuket, Thailand"],
          cn: ["Chill Chill Laguna Phuket, Thailand"],
          ru: ["Chill Chill Laguna Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/spa2/9. Chill Chill Laguna Phuket, Thailand.jpg",
      },
    ],
  },
  {
    id: 3,
    title: {
      en: ["Restaurants"],
      cn: ["餐厅"],
      ru: ["Рестораны"],
    },
    small: {
      en: [""],
      cn: [""],
      ru: [""],
    },
    thumbnail:
      "https://lagunaproperty.com/privilege/restaurant2/1. Angsana Lang Co, Vietnam.jpg",
    image: [
      {
        id: 1,
        caption: {
          en: ["Angsana Lăng Cô, Vietnam"],
          cn: ["Angsana Lăng Cô, Vietnam"],
          ru: ["Angsana Lăng Cô, Vietnam"],
        },
        url:
          "https://lagunaproperty.com/privilege/restaurant2/1. Angsana Lang Co, Vietnam.jpg",
      },
      {
        id: 2,
        caption: {
          en: ["Angsana Morocco, Morocco"],
          cn: ["Angsana Morocco, Morocco"],
          ru: ["Angsana Morocco, Morocco"],
        },
        url:
          "https://lagunaproperty.com/privilege/restaurant2/2. Angsana Morocco, Morocco.JPG",
      },
      {
        id: 3,
        caption: {
          en: ["Angsana Hangzhou, China"],
          cn: ["Angsana Hangzhou, China"],
          ru: ["Angsana Hangzhou, China"],
        },
        url:
          "https://lagunaproperty.com/privilege/restaurant2/3. Angsana Hangzhou, China.jpg",
      },
      {
        id: 4,
        caption: {
          en: ["Angsana Laguna Phuket, Thailand"],
          cn: ["Angsana Laguna Phuket, Thailand"],
          ru: ["Angsana Laguna Phuket, Thailand"],
        },
        url: "https://lagunaproperty.com/privilege/restaurant/7.jpg",
      },
      {
        id: 5,
        caption: {
          en: ["Banyan Tree Samui, Thailand"],
          cn: ["Banyan Tree Samui, Thailand"],
          ru: ["Banyan Tree Samui, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/restaurant2/5. Banyan Tree Samui, Thailand.jpg",
      },
      {
        id: 6,
        caption: {
          en: ["Banyan Tree Ungasan Bali, Indonesia"],
          cn: ["Banyan Tree Ungasan Bali, Indonesia"],
          ru: ["Banyan Tree Ungasan Bali, Indonesia"],
        },
        url: "https://lagunaproperty.com/privilege/restaurant/3.jpg",
      },
      {
        id: 7,
        caption: {
          en: ["Banyan Tree  Mayakoba, Mexico"],
          cn: ["Banyan Tree  Mayakoba, Mexico"],
          ru: ["Banyan Tree  Mayakoba, Mexico"],
        },
        url: "https://lagunaproperty.com/privilege/restaurant/4.jpg",
      },
      {
        id: 8,
        caption: {
          en: ["Banyan Tree Phuket, Thailand"],
          cn: ["Banyan Tree Phuket, Thailand"],
          ru: ["Banyan Tree Phuket, Thailand"],
        },
        url: "https://lagunaproperty.com/privilege/restaurant/6.jpg",
      },
      {
        id: 9,
        caption: {
          en: ["Banyan Tree Macau, China"],
          cn: ["Banyan Tree Macau, China"],
          ru: ["Banyan Tree Macau, China"],
        },
        url:
          "https://lagunaproperty.com/privilege/restaurant2/10. Banyan Tree Macau, China.jpg",
      },
      {
        id: 10,
        caption: {
          en: ["Banyan Tree Shanghai on the Bund, China"],
          cn: ["Banyan Tree Shanghai on the Bund, China"],
          ru: ["Banyan Tree Shanghai on the Bund, China"],
        },
        url: "https://lagunaproperty.com/privilege/restaurant/8.jpg",
      },
      {
        id: 11,
        caption: {
          en: ["Banyan Tree Bangkok, Thailand"],
          cn: ["Banyan Tree Bangkok, Thailand"],
          ru: ["Banyan Tree Bangkok, Thailand"],
        },
        url: "https://lagunaproperty.com/privilege/restaurant/2.jpg",
      },
    ],
  },
  {
    id: 4,
    title: {
      en: ["Gallery merchandise"],
      cn: ["悦榕阁及悦椿阁 精品店"],
      ru: ["Торговые Галереи"],
    },
    small: {
      en: [""],
      cn: [""],
      ru: [""],
    },
    thumbnail: "https://lagunaproperty.com/images/laguna-privillage05.jpg",
    image: [
      {
        id: 1,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/1.jpg",
      },
      {
        id: 2,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/2.jpg",
      },
      {
        id: 3,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/3.jpg",
      },
      {
        id: 4,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/4.jpg",
      },
      {
        id: 5,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/5.JPG",
      },
      {
        id: 6,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/6.jpg",
      },
      {
        id: 7,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/7.JPG",
      },
      {
        id: 8,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/8.JPG",
      },
      {
        id: 9,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/9.JPG",
      },
      {
        id: 10,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/10.JPG",
      },
      {
        id: 11,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/11.jpg",
      },
      {
        id: 12,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/merchandise/12.jpg",
      },
    ],
  },
  {
    id: 5,
    title: {
      en: ["Airport and ferry transfers**"],
      cn: ["机场和渡轮码头的接送**"],
      ru: ["Трансфер до/из аэропорта и паромных переправ**"],
    },
    small: {
      en: ["**Selected destinations only"],
      cn: ["**仅限于可选的旅居地"],
      ru: ["**Только избранные направления"],
    },
    thumbnail: "https://lagunaproperty.com/images/ex-air.jpg",
    image: [
      {
        id: 1,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/airport/1.jpg",
      },
      {
        id: 2,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/airport/2.jpg",
      },
      {
        id: 3,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/airport/3.jpg",
      },
    ],
  },
  {
    id: 6,
    title: {
      en: ["Golf (Phuket, Bintan & Lăng Cô)"],
      cn: ["高尔夫（普吉岛、民丹岛、兰珂）"],
      ru: ["Гольф (Пхукет, Бинтан, Ланг Ко)"],
    },
    small: {
      en: [""],
      cn: [""],
      ru: [""],
    },
    thumbnail:
      "https://lagunaproperty.com/privilege/golf/1. Laguna Golf Phuket.jpg",
    image: [
      {
        id: 1,
        caption: {
          en: ["Laguna Golf Phuket, Thailand"],
          cn: ["Laguna Golf Phuket, Thailand"],
          ru: ["Laguna Golf Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/2. Laguna Golf Phuket.jpg",
      },
      {
        id: 2,
        caption: {
          en: ["Laguna Golf Phuket, Thailand"],
          cn: ["Laguna Golf Phuket, Thailand"],
          ru: ["Laguna Golf Phuket, Thailand"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/3. Laguna Golf Phuket.jpg",
      },
      {
        id: 3,
        caption: {
          en: ["Laguna Golf Phuket, Thailand"],
          cn: ["Laguna Golf Phuket, Thailand"],
          ru: ["Laguna Golf Phuket, Thailand"],
        },
        url: "https://lagunaproperty.com/privilege/airport/3.jpg",
      },
      {
        id: 4,
        caption: {
          en: ["Laguna Golf Bintan, Indonesia"],
          cn: ["Laguna Golf Bintan, Indonesia"],
          ru: ["Laguna Golf Bintan, Indonesia"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/4. Laguna Golf Bintan.jpg",
      },
      {
        id: 5,
        caption: {
          en: ["Laguna Golf Bintan, Indonesia"],
          cn: ["Laguna Golf Bintan, Indonesia"],
          ru: ["Laguna Golf Bintan, Indonesia"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/5. Laguna Golf Bintan.JPG",
      },
      {
        id: 5,
        caption: {
          en: ["Laguna Golf Bintan, Indonesia"],
          cn: ["Laguna Golf Bintan, Indonesia"],
          ru: ["Laguna Golf Bintan, Indonesia"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/6. Laguna Golf Bintan.JPG",
      },
      {
        id: 6,
        caption: {
          en: ["Laguna Golf Lăng Cô, Vietnam"],
          cn: ["Laguna Golf Lăng Cô, Vietnam"],
          ru: ["Laguna Golf Lăng Cô, Vietnam"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/7. Laguna Golf Lang Co.jpg",
      },
      {
        id: 7,
        caption: {
          en: ["Laguna Golf Lăng Cô, Vietnam"],
          cn: ["Laguna Golf Lăng Cô, Vietnam"],
          ru: ["Laguna Golf Lăng Cô, Vietnam"],
        },
        url:
          "https://lagunaproperty.com/privilege/golf/8. Laguna Golf Lang Co.jpg",
      },
    ],
  },
  {
    id: 7,
    title: {
      en: ["In-house tours"],
      cn: ["内部参观"],
      ru: ["Внутренние экскурсионные туры"],
    },
    small: {
      en: [""],
      cn: [""],
      ru: [""],
    },
    thumbnail: "https://lagunaproperty.com/privilege/tour/7.JPG",
    image: [
      {
        id: 1,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/tour/MMB_7495.JPG",
      },
      {
        id: 2,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/tour/2.jpg",
      },
      {
        id: 3,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/tour/MMB_7201.JPG",
      },
      {
        id: 4,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/tour/5.jpg",
      },
      {
        id: 5,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/tour/6.jpg",
      },
      {
        id: 5,
        caption: {
          en: [""],
          cn: [""],
          ru: [""],
        },
        url: "https://lagunaproperty.com/privilege/tour/MMB_8553.JPG",
      },
    ],
  },
];

export default {
  content,
  imageContent,
};



// WEBPACK FOOTER //
// ./src/data/SanctuaryClub/privileges.js